import { useTranslation } from 'react-i18next';
import FeatureImg01 from '#app/assets/images/app1.png';
import FeatureImg02 from '#app/assets/images/app2.png';
import FeatureImg03 from '#app/assets/images/app5.png';
import Highlighter, { HighlighterItem } from './highlighter';
import Particles from './particles';

const items = [
	{
		title: 'features2.items.hl7_loinc.title',
		description: 'features2.items.hl7_loinc.description',
	},
	{
		title: 'features2.items.hipaa_baa.title',
		description: 'features2.items.hipaa_baa.description',
	},
	{
		title: 'features2.items.gdpr_compatible.title',
		description: 'features2.items.gdpr_compatible.description',
	},
	{
		title: 'features2.items.fda_21cfr_part11.title',
		description: 'features2.items.fda_21cfr_part11.description',
	},
	{
		title: 'features2.items.audit_trail.title',
		description: 'features2.items.audit_trail.description',
	},
	{
		title: 'features2.items.real_time_integration.title',
		description: 'features2.items.real_time_integration.description',
	},
	{
		title: 'features2.items.dpa_agreement.title',
		description: 'features2.items.dpa_agreement.description',
	},
	{
		title: 'features2.items.iso_security.title',
		description: 'features2.items.iso_security.description',
	},
	{
		title: 'features2.items.multi_platform_support.title',
		description: 'features2.items.multi_platform_support.description',
	},
];

export default function Features02() {
	const { t } = useTranslation();

	return (
		<section className="relative">
			{/* Particles animation */}
			<div className="absolute left-1/2 top-0 -z-10 -ml-32 -mt-24 h-80 w-80 -translate-x-1/2">
				<Particles
					className="absolute inset-0 -z-10"
					quantity={6}
					staticity={30}
				/>
			</div>

			<div className="mx-auto max-w-6xl px-4 sm:px-6">
				<div className="pt-16 md:pt-32">
					{/* Section header */}
					<div className="mx-auto max-w-3xl pb-12 text-center md:pb-20">
						<h2 className="h2 bg-gradient-to-r from-slate-200/60 via-slate-200 to-slate-200/60 bg-clip-text pb-4 text-transparent">
							{t('features2.performance_title')}
						</h2>
						<p className="text-lg text-slate-400">
							{t('features2.performance_description')}
						</p>
					</div>

					{/* Highlighted boxes */}
					<div className="relative pb-12 md:pb-20">
						{/* Blurred shape */}
						<div
							className="pointer-events-none absolute bottom-0 left-1/2 -mb-20 -translate-x-1/2 opacity-50 blur-2xl"
							aria-hidden="true"
						>
							<svg xmlns="http://www.w3.org/2000/svg" width="434" height="427">
								<defs>
									<linearGradient
										id="bs2-a"
										x1="19.609%"
										x2="50%"
										y1="14.544%"
										y2="100%"
									>
										<stop offset="0%" stopColor="#38B2AC" />
										<stop offset="100%" stopColor="#38B2AC" stopOpacity="0" />
									</linearGradient>
								</defs>
								<path
									fill="url(#bs2-a)"
									fillRule="evenodd"
									d="m346 898 461 369-284 58z"
									transform="translate(-346 -898)"
								/>
							</svg>
						</div>
						{/* Grid */}
						<Highlighter className="group grid gap-6 md:grid-cols-12">
							{/* Box #1 */}
							<div className="md:col-span-12" data-aos="fade-down">
								<HighlighterItem>
									<div className="relative z-20 h-full overflow-hidden rounded-[inherit] bg-slate-900">
										<div className="flex flex-col md:flex-row md:items-center md:justify-between">
											{/* Blurred shape */}
											<div
												className="absolute right-0 top-0 blur-2xl"
												aria-hidden="true"
											>
												<svg
													xmlns="http://www.w3.org/2000/svg"
													width="342"
													height="393"
												>
													<defs>
														<linearGradient
															id="bs-a"
															x1="19.609%"
															x2="50%"
															y1="14.544%"
															y2="100%"
														>
															<stop offset="0%" stopColor="#38B2AC" />
															<stop
																offset="100%"
																stopColor="#38B2AC"
																stopOpacity="0"
															/>
														</linearGradient>
													</defs>
													<path
														fill="url(#bs-a)"
														fillRule="evenodd"
														d="m104 .827 461 369-284 58z"
														transform="translate(0 -112.827)"
														opacity=".7"
													/>
												</svg>
											</div>
											{/* Radial gradient */}
											<div
												className="pointer-events-none absolute bottom-0 left-1/2 -z-10 flex aspect-square h-full -translate-x-1/2 translate-y-1/2 items-center justify-center"
												aria-hidden="true"
											>
												<div className="translate-z-0 absolute inset-0 rounded-full bg-teal-500 opacity-70 blur-[120px]" />
												<div className="translate-z-0 absolute h-1/4 w-1/4 rounded-full bg-teal-400 blur-[40px]" />
											</div>
											{/* Text */}
											<div className="order-1 shrink-0 p-6 pt-0 md:order-none md:max-w-[480px] md:p-8 md:pr-0">
												<div className="mb-5">
													<div>
														<h3 className="inline-flex bg-gradient-to-r from-slate-200/60 via-slate-200 to-slate-200/60 bg-clip-text pb-1 text-xl font-bold text-transparent">
															{t('features2.ui_ux_title')}
														</h3>
														<p className="text-slate-400">
															{t('features2.ui_ux_description')}
														</p>
													</div>
												</div>
											</div>
											{/* img */}
											<div className="relative h-64 w-full overflow-hidden md:h-auto">
												<img
													className="md:left-0{md}transla{}-x-0 absolute bottom-0 left-1/2 mx-auto mb-4 max-w-none -translate-x-1/2 opacity-70 md:relative md:mb-0"
													src={FeatureImg01}
													width="504"
													height="400"
													alt="Feature 01"
												/>
											</div>
										</div>
									</div>
								</HighlighterItem>
							</div>
							{/* Box #2 */}
							<div className="md:col-span-7" data-aos="fade-down">
								<HighlighterItem>
									<div className="relative z-20 h-full overflow-hidden rounded-[inherit] bg-slate-900">
										<div className="flex flex-col">
											{/* Radial gradient */}
											<div
												className="pointer-events-none absolute bottom-0 left-1/2 -z-10 aspect-square w-1/2 -translate-x-1/2 translate-y-1/2"
												aria-hidden="true"
											>
												<div className="translate-z-0 absolute inset-0 rounded-full bg-slate-800 blur-[80px]" />
											</div>
											{/* Text */}
											<div className="order-1 shrink-0 p-6 pt-0 md:order-none md:max-w-[480px] md:p-8">
												<div>
													<h3 className="inline-flex bg-gradient-to-r from-slate-200/60 via-slate-200 to-slate-200/60 bg-clip-text pb-1 text-xl font-bold text-transparent">
														{t('features2.modern_title')}
													</h3>
													<p className="text-slate-400">
														{t('features2.modern_description')}
													</p>
												</div>
											</div>
											{/* img */}
											<div className="relative mb-8 h-64 w-full overflow-hidden md:mb-0 md:h-auto">
												<img
													className="absolute bottom-0 left-1/2 mx-auto min-w-60 max-w-none -translate-x-1/2 opacity-70 md:relative md:left-0 md:max-w-full md:translate-x-0"
													src={FeatureImg02}
													alt="Feature 02"
												/>
											</div>
										</div>
									</div>
								</HighlighterItem>
							</div>
							{/* Box #3 */}
							<div className="md:col-span-5" data-aos="fade-down">
								<HighlighterItem>
									<div className="relative z-20 h-full overflow-hidden rounded-[inherit] bg-slate-900">
										<div className="flex flex-col">
											{/* Radial gradient */}
											<div
												className="pointer-events-none absolute bottom-0 left-1/2 -z-10 aspect-square w-1/2 -translate-x-1/2 translate-y-1/2"
												aria-hidden="true"
											>
												<div className="translate-z-0 absolute inset-0 rounded-full bg-slate-800 blur-[80px]" />
											</div>
											{/* Text */}
											<div className="order-1 shrink-0 p-6 pt-0 md:order-none md:max-w-[480px] md:p-8">
												<div>
													<h3 className="inline-flex bg-gradient-to-r from-slate-200/60 via-slate-200 to-slate-200/60 bg-clip-text pb-1 text-xl font-bold text-transparent">
														{t('features2.traceability_title')}
													</h3>
													<p className="text-slate-400">
														{t('features2.traceability_description')}
													</p>
												</div>
											</div>
											{/* img */}
											<div className="relative mb-8 h-64 w-full overflow-hidden sm:h-auto md:mb-0">
												<img
													className="absolute bottom-0 left-1/2 mx-auto max-w-none -translate-x-1/2 opacity-70 md:relative md:left-0 md:max-w-full md:translate-x-0"
													src={FeatureImg03}
													alt="Feature 03"
												/>
											</div>
										</div>
									</div>
								</HighlighterItem>
							</div>
						</Highlighter>
					</div>

					{/* Features list */}
					<div className="grid gap-8 md:grid-cols-3 md:gap-12">
						{items.map((item, index) => (
							<div key={index}>
								<div className="mb-1 flex items-center space-x-2">
									<h4 className="font-medium text-slate-50">{t(item.title)}</h4>
								</div>
								<p className="text-sm text-slate-400">{t(item.description)}</p>
							</div>
						))}
					</div>
				</div>
			</div>
		</section>
	);
}
